import React from 'react';

import './ComparisonTable.css';

// Interface for a row in the comparison table
interface ComparisonRow {
  feature: string;
  starter: string | boolean;
  professional: string | boolean;
  enterprise: string | boolean;
}

// Props interface for the ComparisonTable component
interface ComparisonTableProps {
  data: ComparisonRow[];
}

const ComparisonTable: React.FC<ComparisonTableProps> = ({ data }) => {
  const CheckIcon: React.FC = () => (
    <svg
      className="check-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 12L10 17L20 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const XIcon: React.FC = () => (
    <svg className="x-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const renderValue = (value: string | boolean): React.ReactNode => {
    if (typeof value === 'boolean') {
      return value ? <CheckIcon /> : <XIcon />;
    }
    return value;
  };

  return (
    <section className="compare-plans container">
      <div className="section-heading">
        <h2>Compare Plans</h2>
        <p>Find the perfect CyberRaven plan for your healthcare organization</p>
      </div>

      <table className="comparison-table">
        <thead>
          <tr>
            <th>Features</th>
            <th>Starter</th>
            <th>Professional</th>
            <th>Enterprise</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td>{row.feature}</td>
              <td>{renderValue(row.starter)}</td>
              <td>{renderValue(row.professional)}</td>
              <td>{renderValue(row.enterprise)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

export default ComparisonTable;
